import moment from 'moment'

let general = {
	monthsArray: [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	],
	monthsArrayAbbrev: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
	monthsDiff: (start, end) => {
		let a = moment.unix(start)
		let b = moment.unix(end)
		return b.diff(a, "months")
	},
	yearsDiff: (start, end) => {
		let a = moment.unix(start)
		let b = moment.unix(end)
		return b.diff(a, "years")
	},
	yearsBetween: (start, end) => {
		const years = []
		const dateStart = moment.unix(start)
		const dateEnd = moment.unix(end)
		while (dateEnd.diff(dateStart, "years") >= 0) {
			years.push(dateStart.format("YYYY"))
			dateStart.add(1, "year")
		}
		return years
	}
}

export default general